import { NavigationHelper } from './../custom-shared/util/NavigationHelper';
import { MasterVisualizarMeuCadastroService } from './../features/master/visualizar-meu-cadastro/master-visualizar-meu-cadastro.service';
import { DialogBoxService } from './../custom-shared/components/alerts/dialog-box-service';
import { MasterCreateUserService } from './../features/master/create-user/master-create-user.service';
import { CustomAuthenticationService } from './../auth/services/custom-authentication.service';
import { environment } from '@env/environment';
import { state, style, trigger } from '@angular/animations';
import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import {
  ProfileType
} from '@app/custom-shared/enums/permissions-type.enum'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MasterVisualizarMeuCadastroComponent } from '@app/features/master/visualizar-meu-cadastro/master-visualizar-meu-cadastro.component';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { TranslateService } from '@ngx-translate/core';
import { MenuService } from '@services/menu/menu.service';
import { MessagesService } from '@services/messages/message.service';
import { TranslatorService } from '@services/translator/translator.service';
import { interval, Subject, Observable, forkJoin } from 'rxjs';
import { filter, takeUntil, map } from 'rxjs/operators';
import { ProfileManagerService } from '@app/custom-shared/services/profile-manager.service';
import { SpinnerService } from '@app/custom-service/spinner.service';
import { ProgressSpinnerMode, ThemePalette } from '@angular/material';
import { CryptoService } from '@app/core/services/crypto/crypto.service';
import {
  EventMessage,
  EventType,
} from '@azure/msal-browser';
import { apiConfig } from '@app/app-config';
import { SessionService } from '@app/custom-shared/services/session-service/session.service';
import { Title } from '@angular/platform-browser';
import { MainComponent } from '@app/home/home.component';
import { ISoapMethodResponse, Client, NgxSoapService } from 'ngx-soap';
import { User } from '@app/core/models/user.model';
import { HomeService } from '@app/home/home.component.service';
import * as moment from 'moment';
import { ParametersSearchSecurityPortfolioMenuComponent } from '@app/features/parameters/search-security-portfolio-menu/parameters-search-security-portfolio-menu.component';
import { Router, Event, NavigationStart } from '@angular/router';
import { PermissionsType } from '@app/custom-shared/enums/permissions-type.enum';
import { authService } from '@app/core/services-api/auth.service';
import { MessageService } from 'primeng/api';
import { FeatureService } from "@services/feature/feature.service";
import { HomeAcessoRapidoService } from '@app/features/dashboard/dashboard-home/home-acesso-rapido/home-acesso-rapido.service';
import { SecurityPortfolioService } from '@app/core/services-api/security-portfolio.service';
import { HttpClient } from '@angular/common/http';
import { SharedVariable } from '@app/custom-shared/util/shared-variable';
import { MasterClienteCreateUserService } from '@app/features/master/master-cliente/cliente-criar-usuario-stepper/master-cliente-create-user.service';
import { widgets } from '../../assets/widgets/widgetsConf';
import { AppComponent } from '@app/app.component';
import { CookieService } from 'ngx-cookie-service';
import { ExceptionCutOffTimeService } from '@app/core/services-api/exception-cut-off-time.service';
import { isEmpty } from 'lodash';
import { LocalService } from '@app/shared/services/local.service';
const SOAP_URL = environment.soap_ticket;
const B2C_CHANGE_URL = environment.b2cChangePassword;
// const B2C_AUTHORITY_PASSWORD_RESET = environment.b2cAuthorityPasswordReset;

export const TIME_TO_EXPIRE_SESSION = 1800000;


//import { homedir } from 'os';
/**
 * Home application component which displays the main menu, dashboard, business features...
 */

@Component({
  selector: 'app-custom-home',
  templateUrl: './custom-home.component.html',
  styleUrls: ['./custom-home.component.scss'],
  animations: [
    trigger('workspace-animation', [
      state(
        'collapsed',
        style({
          transform: 'translateY(0px) perspective(10px) rotateX(1deg)',
        }),
      ),
      state(
        'expanded',
        style({
          transform: 'translateY(-120px) perspective(10px) rotateX(1deg)',
        }),
      ),
    ]),
  ],
})
export class CustomHomeComponent implements OnInit, AfterViewInit, OnDestroy, AfterViewChecked {
  widgets: any
  hasAtivoOperPermission: any = false;
  hasPassivoOperPermission: any = false;
  taskbarHeight: any
  dialogPosition: any
  workSpaceId = 0;
  displayBarMenu = false;
  isDisplayed: boolean;
  openSideBarMenu = false;
  openWorspaceBar = false;
  expandedState = 'collapsed';
  MENU_ITEMS = 'Menu Items.';
  dialogConfig: any;
  token: string;
  offPage = false;
  client: Client;
  logoutHome = false;
  display = false;
  displayDashboard = false;
  loaderClients
  showLoading = false;
  ManualDoUsario: any;
  linkCookies: string;
  showCookieDetails = false;

  /**
   * The base path of your REST API calls
   */
  BASE_PATH = environment.basePath
  /**
   * The Subjet emitter object to destroy all the subscriptions
   * when the component is destroyed
   */
  destroy$: Subject<boolean> = new Subject<boolean>()
  /**
   * The title of the current opened page
   */
  screenTitle = ''
  /**
   * Option to expand or collapse the main menu's panel
   */
  menuExpanded = false
  /**
   * The current styleName of the current page
   */
  styleClass
  // palmyra-needle-add-menu-entry: Do not delete this line

  isOpen = false;
  isAtivoOpen :boolean;
  isDashboardOpen :boolean;
  menu_child: any[] = [];

  isMenuOpened = false;

  timerclass = 'initial';

  // palmyra-needle-add-menu-entry: Do not delete this line
  menu = [];

  // CUSTOM MENU
  master = false;
  dashboard = false;
  home = true;

  ConsultarLogs: boolean;
  msgCookies: string;
  moreInformationMsg: string
  cookieDetailsMsg: string
  acceptBtnMsg: string
  hasMasterPermission = false;
  // hasDashboardPermission = false;
  /* Do not write your custom code here, it will be replaced by the generated content */
  // end palmyra-needle-add-menu-entry

  hideClock = true;
  maxTime = TIME_TO_EXPIRE_SESSION; //900000
  time = TIME_TO_EXPIRE_SESSION;
  halfTime = (0.3 * TIME_TO_EXPIRE_SESSION);
  endTime = (0.067 * TIME_TO_EXPIRE_SESSION);
  elmClock;
  objectEmail:any;
  user: User;
  mailUser: any;
  userSso: any;
  initials: string;
  MeuCadastro: any;
  portfolioCode: any;
  alterarSenha: any;
  pageReloaded: any;
  encerrar: any;
  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:keydown', ['$event'])
  @HostListener('document:click', ['$event'])
  onEvent(e) {
    this.resetTimer();
  }
  permissions = this.secureStorage.getJsonValue('permissions');

  show = false;
  color: ThemePalette = 'warn';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 50;
  cookieAccepted = true;
  constructor(
    private serviceException: ExceptionCutOffTimeService,
    private profileManager: ProfileManagerService,
    private masterClienteCreateUserService: MasterClienteCreateUserService,
    public shared: SharedVariable,
    private httpClient: HttpClient,
    private homeAcessoRapidoService: HomeAcessoRapidoService,
    private customAuthenticationService: CustomAuthenticationService,
    private featureService: FeatureService,
    private menuService: MenuService,
    private homeService: HomeService,
    private service: SecurityPortfolioService,
    private translate: TranslateService,
    private translatorService: TranslatorService,
    private messageService: MessagesService,
    private soap: NgxSoapService,
    private msalService: MsalService,
    private dialog: MatDialog,
    private titleService: Title,
    private spinnerService: SpinnerService,
    private profileManagerService: ProfileManagerService,
    private cdRef: ChangeDetectorRef,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private router: Router,
    private appComponent: AppComponent,
    private messageServicess: MessageService,
    private authServices: authService,
    private cookiesService: CookieService,
    mainComponent: MainComponent,
    private userService: MasterCreateUserService,
    private snackBarService: DialogBoxService,
    private accountService: MasterVisualizarMeuCadastroService,
    private secureStorage: LocalService,
    private elementRef: ElementRef, private renderer: Renderer2
  ) {

    this.pageReloaded = window.performance
      .getEntriesByType('navigation')
      .map((nav) => (nav as any).type)
      .includes('reload');
    this.widgets = widgets;
    this.menu = this.setUpActiveRoute(mainComponent.menu);
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.display = false;
        this.displayDashboard = false;
      }
    });
  }

  setUpActiveRoute(menu: any[]): any[] {
    menu.forEach(element => {
      if (element.id === 'active') {
        element.link = ['/active'];
      }
    });
    return menu;
  }

  isAtivoEmpty() {
   // let permission = this.customAuthenticationService
    let empty = !this.customAuthenticationService.hasPermission("Ativos - Ajuda")
      && !this.customAuthenticationService.hasPermission("Ativos - Operações")
      && !this.customAuthenticationService.hasPermission("Ativos - Contratos e Documentos")
      && !this.customAuthenticationService.hasPermission("Ativos / Relatórios")
    return empty
  }
  /**
   * Initialize the min component
   * @returns {void}
   */
  hasSecurityBoolean: boolean;
  hasSecurityPortfolio() {
    this.authServices.hasSecurityPortfolio().subscribe(res => {

      if (!res) {
        let msgHasSecurityPortfolio: any;
        this.featureService.translatorService
          .getMessage('msgHasSecurityPortfolio')
          .subscribe(val => {
            this.messageServicess.add({
              severity: 'error', detail: val,
            });
          })
        setTimeout(() => {
          this.logout();
        }, 5000);
      }

    },
      (error => {
        if ((error.status === 401) && !this.hasSecurityBoolean) {
          this.hasSecurityBoolean = true;
          this.hasSecurityPortfolio();
        } else {
          this.featureService.translatorService
            .getMessage('msgHasSecurityPortfolio')
            .subscribe(val => {
              this.messageServicess.add({
                severity: 'error', detail: val,
              });
            })
          setTimeout(() => {
            this.logout();
          }, 5000);
        }

      }))
  }
  getLoggedUserName() {
    this.homeAcessoRapidoService.getLoggedUser()
      .subscribe(response => {
        this.mailUser = response.login;
      })
  }
  getUserSSo() {
    this.homeAcessoRapidoService.getUserSSO()
      .subscribe(response => {
        this.userSso = response;

      })

  }
  getCurrentConfig(){
    this.service.findAllPtfConfiguration().subscribe(selectedItems => {
      /* if (selectedItems.length && (!sessionStorage.getItem('portfolioCode')|| !sessionStorage.getItem('PortfolioConfigCode')) ) {
        sessionStorage.setItem('portfolioCode', JSON.stringify(selectedItems[0]));
        sessionStorage.setItem('PortfolioConfigCode', JSON.stringify(selectedItems[0]));
      } */
      if (this.isMasterClient() && selectedItems.length == 0) {
        console.log("MASTER CLIENT")
        let msgHasSecurityPortfolio: any;
        this.featureService.translatorService
          .getMessage('msgHasSecurityPortfolio')
          .subscribe(val => {
            this.messageServicess.add({
              severity: 'error', detail: val,
            });
          })

        setTimeout(() => {
          this.logout();
        }, 2000);
      }
      if(selectedItems.length && this.isOperator()){
        this.secureStorage.setJsonValue('portfolioCode', JSON.stringify(selectedItems[0]));
        this.secureStorage.setJsonValue('PortfolioConfigCode', JSON.stringify(selectedItems[0]));

      }
      else{

      
      if (selectedItems.length) {
        let allConfs = [...selectedItems];
      const containsGlobalConfigs = selectedItems.some(element=>element.identifier.includes("GLOBOL_CONF_G_"))
      selectedItems = containsGlobalConfigs ? selectedItems.filter(element=>element.identifier.includes("GLOBOL_CONF_G_")).filter(globalConf=>{
        const nonGlobalConfs = allConfs.filter(item => !item.identifier.includes("GLOBOL_CONF_G_"));
        return nonGlobalConfs.some(item => item.portfolioCode === globalConf.portfolioCode)
      }) : selectedItems
       if (selectedItems.length==0&&this.isMasterClient()){
        this.featureService.translatorService
        .getMessage('msgHasSecurityPortfolio')
        .subscribe(val => {
          this.messageServicess.add({
            severity: 'error', detail: val,
          });
        })

      setTimeout(() => {
        this.logout();
      }, 2000);

      }else{
        let currentConigFound = false;
      
        this.secureStorage.setJsonValue('portfolioCode', JSON.stringify(selectedItems[0]));
        this.secureStorage.setJsonValue('PortfolioConfigCode', JSON.stringify(selectedItems[0]));
      

      selectedItems.forEach(element => {
        if (element?.currentConfig == true) {
          this.secureStorage.setJsonValue('portfolioCode', JSON.stringify(element));
          this.secureStorage.setJsonValue('PortfolioConfigCode', JSON.stringify(element));
          currentConigFound = true;
        }


      });
      if (!currentConigFound){ 
        this.secureStorage.setJsonValue('portfolioCode', JSON.stringify(selectedItems[0]));
        this.secureStorage.setJsonValue('PortfolioConfigCode', JSON.stringify(selectedItems[0]));
        this.service.setCurrentPTFConfig(selectedItems[0].identifier).subscribe(res=>{
          location.reload();
        })


      }

      }
      
    }
  }
      this.shared.loaderForDashboard = true;
      this.showLoading = true;
      this.getPTFBYUSER()

      if(this.shared.mailUser ==="" || this.shared.mailUser === undefined || this.shared.mailUser === null){
        this.homeAcessoRapidoService.getLoggedUser()
        .subscribe(response => {
          this.objectEmail = {"email": response.login };
        })
      }
    });
  }

  ngOnInit() {
    this.shared.loaderForDashboard = false;
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
    this.shared.datePNL = new Date() // reset the date for menu fundos globally
    

    this.ConsultarLogs = this.customAuthenticationService.hasPermission("Consultar Logs");
    this.translateUserMenu();
    this.translatorService.translateMenuItem(this.menu);
    //this.menu = this.menuService.filterByRole(this.menu);
    this.elmClock = document.getElementById('timer');
    this.timeout_control();

    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = true;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.hasBackdrop = true;
    this.dialogConfig.height = '90vh';
    this.dialogConfig.width = '92vw';
    this.dialogConfig.maxWidth = '100vw';

    //this.msalInit();
    this.initToSetCurrentConfig()
    //this.init();
    if (localStorage.s3brazilwebportalfe_locale_id == 'en') {
      this.msgCookies = "We use cookies to improve our services by analyzing your browsing habits. If you continue browsing this page, we consider that you accept its use under the terms indicated in the Privacy Policy.";
      this.acceptBtnMsg = "Accept"
      this.moreInformationMsg = "More informations (PDF)"
      this.cookieDetailsMsg = "More details"
      this.linkCookies = "assets/files/Cookies Policy - S3CACEIS.pdf"
    } else {
      this.msgCookies = "Usamos cookies para melhorar nossos serviços, mediante a análise de seus hábitos de navegação. Se continuar navegando nesta página, consideramos que aceita seu uso nos termos indicados na Política de Privacidade."
      this.acceptBtnMsg = "ACEITO"
      this.moreInformationMsg = "Mais Informações (PDF)"
      this.cookieDetailsMsg = "Mais detalhes"
      this.linkCookies = "assets/files/Politica de Cookies - Site.pdf"
    }
    this.taskbarHeight = window.screen.height - window.screen.availHeight;
    if (this.taskbarHeight > 50) {
      this.dialogPosition = '32%'
    } else {
      this.dialogPosition = '40%'
    }
  }

  setCookies(event: any) {
    if (event) {
      this.isDisplayed = false;
      this.showCookieDetails = false;
      this.agreeCookies()
    }
  }

  openCookieDetails() {
    this.isDisplayed = false;
    this.showCookieDetails = true;
  }
  translateUserMenu() {
    this.featureService.translatorService
      .getMessage('Meu cadastro')
      .subscribe(val => {
        this.MeuCadastro = val
      })
    this.featureService.translatorService
      .getMessage('Portfólio Code')
      .subscribe(val => {
        this.portfolioCode = val
      })
    this.featureService.translatorService
      .getMessage('Alterar senha')
      .subscribe(val => {
        this.alterarSenha = val
      })
    this.featureService.translatorService
      .getMessage('Encerrar sessão')
      .subscribe(val => {
        this.encerrar = val
      })
  }
  openLoginUnicoTest() {
    const url = this.router.serializeUrl(this.router.createUrlTree(['admin']));
    window.open(url, '_blank');
  }
  changeCursorToHourglass() {
    if(!this.showLoaderPassivo){
    this.router.navigateByUrl('/dashboard');
    let loadingMessage:string;
    this.featureService.translatorService.getMessage('Carregando SantanderOper').subscribe(
      data=>loadingMessage=data
    )
    const element = document.getElementById('cursor2')
    // element.style.cursor = "url('../portal/assets/img/sand-clock.png') 2 2 , auto";
    this.snackBarService.dismissSnackbar()

    this.renderer.setStyle(element, 'cursor','progress');
    this.snackBarService.snackbarUtil.showLoad(loadingMessage);}
  }
  
  resetCursor() {
    const element = document.getElementById('cursor2')
    this.renderer.setStyle(element, 'cursor','auto' );
    this.snackBarService.dismissSnackbar()

  }
  showLoaderPassivo=false;
  showLoaderSantanderOper=false;
  santanderOperAuthentication(system: string){
    this.showLoaderSantanderOper = false;
    this.authenticate(system)
  }
  passivoAndOperAuthentication(system: string) {
    if(!this.showLoaderPassivo){

    
    this.showLoaderPassivo=true;
    this.authenticate(system)
    

  }}
authenticate(system){
  let noSsoErr,notAllowedErr:string;
    this.featureService.translatorService.getMessage('O usuário não tem logon único').subscribe(
      data=>noSsoErr=data
    )
    this.featureService.translatorService.getMessage('user is not allowed to access').subscribe(
      data=>notAllowedErr=data
    )
    if (this.userSso ) {
      let cpf = ""
      let name = ""
      let loginSso = ""
      let objectEmail = { "email": this.shared.mailUser };
      if(objectEmail.email ==="" || objectEmail.email === undefined || objectEmail.email === null){
        objectEmail = this.objectEmail
      }
      let login = ""
      //  is connected user MBO
      if (this.isMasterBO()) {
        login = ""
        this.accountService.getUserByEmail(objectEmail).toPromise().then(res => {
          cpf = res.cpf
          name = res.name
          loginSso = res.userSso

          // this.soap.createClient(SOAP_URL).then(client => this.client = client);
          let body = {
            "login": login,
            "name": loginSso == null ? name : loginSso,
            "cpf": cpf
          }
         
          this.userService.consultUserSSO(body).subscribe(res1 => {
            
            if (Number(res1.result) < 100) {
              
              this.homeAcessoRapidoService.loginSso(loginSso, this.shared.mailUser, system).subscribe((data) => {
                
                //window.open("https://www.santanderoper.com.br/" + system.toLowerCase() + "/Html/IsantAccess?ticket=+URLEnconder.encode(TicketService.generateTicket(" + data.ticket + "),UTF-8)", "_blank");
                //console.log(encodeURIComponent(data.ticket))
                  if (system == "n7") {
                    window.open(environment.loginSSO + system.toLowerCase() + "/Html/IsantAccess?sistema=N7&ticket=" + encodeURIComponent(data.ticket), "_blank");
                  }
                  else {
                    window.open(environment.loginSSO + system.toLowerCase() + "/Nets/login.aspx?ticket=" + encodeURIComponent(data.ticket), "_blank");
                    
                  }
                  this.resetCursor();
           // this.showLoaderPassivo=false;
          }
          , error => {
            setTimeout(() => {
              this.showLoaderPassivo=false;
            }, 1500)
          } );
        } else {
          setTimeout(() => {
            this.showLoaderPassivo=false;
      //      this.resetCursor();
            this.snackBarService.snackbarUtil.showError(
              notAllowedErr,
            );
          }, 1500)
        }
              }, error => {
                setTimeout(() => {
                  this.resetCursor();
                  this.showLoaderPassivo=false;
                  
                }, 1500)
                
                //TODO: add message to inform user that there is an issue when trying to get ticket
             //   this.resetCursor()
              }
              , () => {
             
          })
        })
      } else {
        this.customAuthenticationService
          .getUser().then(res => {
            // this.userService.getCreatedUser(res.id).subscribe(res => {
              // if (res) {
                // this.userService.getCreatorUser(res.creatorUserId).subscribe(res => {
                //   login = res[0].userSso
                  let parentSSO = res.parentSSO
                 
                  this.accountService.getUserByEmail(objectEmail).toPromise().then(res => {
                    cpf = res.cpf
                    name = res.name
                    loginSso = res.userSso
                    // this.soap.createClient(SOAP_URL).then(client => this.client = client);
                    let body = {
                      // "login": this.isMasterBO() ? "" : this.msalService.instance.getAllAccounts()[0].name,
                      "login": login,
                      "name": loginSso == null ? name : loginSso,
                      "cpf": cpf
                    }
                    //this.resetCursor();
                    this.userService.consultUserSSOPassivo(body,parentSSO).subscribe(res => {
                      if (Number(res.result) < 100) {
                        
                        this.homeAcessoRapidoService.loginSso(loginSso, this.shared.mailUser, system).subscribe((data) => {
                          //window.open("https://www.santanderoper.com.br/" + system.toLowerCase() + "/Html/IsantAccess?ticket=+URLEnconder.encode(TicketService.generateTicket(" + data.ticket + "),UTF-8)", "_blank");
                          //console.log(encodeURIComponent(data.ticket))
                          if (system == "n7") {
                            window.open(environment.loginSSO + system.toLowerCase() + "/Html/IsantAccess?sistema=N7&ticket=" + encodeURIComponent(data.ticket), "_blank");
                          }
                          else {
                            window.open(environment.loginSSO + system.toLowerCase() + "/Nets/login.aspx?ticket=" + encodeURIComponent(data.ticket), "_blank");

                          }
                          this.resetCursor();
                   //      this.showLoaderPassivo=false;
                        }, error => {
                          setTimeout(() => {
                           
                            this.showLoaderPassivo=false;
                            
                          }, 1500)
                        });
                      } else {
                        setTimeout(() => {
                          this.showLoaderPassivo=false
                   //       this.resetCursor();
                          this.snackBarService.snackbarUtil.showError(
                            notAllowedErr,
                          );
                        }, 1500)
                      }
                    }, error => {
                      this.showLoaderPassivo=false
                      //TODO: add message to inform user that there is an issue when trying to get ticket
                      //this.resetCursor()
                    }
                    , () => {
                   
                })
                  })
                // })
              // }
            // })
          })
      }




    }
    else {
      this.showLoaderPassivo=false
      this.resetCursor();
      setTimeout(() => {
        this.showLoaderPassivo=false
        this.resetCursor();
        noSsoErr.showError()

      }, 1500)

    }
}
  msalInit() {
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter(
          (msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS,
        ),
      )
      .subscribe({
        next: (result: any) => {
          if (result.payload.account) {
            this.authService.instance.setActiveAccount(result.payload.account);
          }
        },
        error: error => console.log(error),
      });
  }

  filterMenu(menu: any[]): any[] {
    if (this.permissions) {
      return this.menuService.filterByRole(menu);
    } else {
      setTimeout(() => {
        this.permissions = this.secureStorage.getJsonValue('permissions');

        this.filterMenu(menu);
      }, 1000);
    }
  }
  /***
   * Add styleName to html root element
   */
  ngAfterViewInit() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
    this.spinnerService.httpProgress().subscribe((status: boolean) => {
      if (status) {
        this.show = true;
      } else {
        this.show = false;
      }
    });
    (document.querySelector('html') as HTMLElement).className = 'home';
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }
  changePassword() {
    let ui_locales:string ;
    if(localStorage.getItem("s3brazilwebportalfe_locale_id")  !=="pt"){
      ui_locales="en"
      let ui_locales_param="&ui_locales="+ui_locales;
    window.location.href = `${B2C_CHANGE_URL}${ui_locales_param}`;
    }else{
      window.location.href = `${B2C_CHANGE_URL}`;
    }
  }
//   changePassword() {
//   const locale = localStorage.getItem("s3brazilwebportalfe_locale_id") !== "pt" ? "en" : "pt-BR";
 
//   this.msalService.loginRedirect({
//      authority: `${B2C_AUTHORITY_PASSWORD_RESET}`,
//      scopes: ["openid", "profile", "offline_access"],
//     extraQueryParameters: {
//       prompt: "login",
//       ui_locales: locale
//     }
//   });
// }

  /**
   * Clear the tokens from the sessionStorage after logout and redirect to the login page
   */
  isLoggedOut :boolean = false;
  logout() {
    if(!this.isLoggedOut){
      this.isLoggedOut = true
      this.showLoading = false
    this.authServices.logout().subscribe(res => {
    },
      (error) => {
      }, () => {
        sessionStorage.clear();
        let loginDisplay = this.msalService.instance.getAllAccounts()[0];
        const firstWebService$ = this.msalService.acquireTokenSilent({
          account: loginDisplay,
          redirectUri: environment.msalUrl,
          scopes: apiConfig.scopes,
        });
        const secondWebService$ = firstWebService$.pipe(
          map((authResult: any) => {
            return this.msalService.logout({ idTokenHint: `${authResult.idToken}` });
          })  
        );
        forkJoin([firstWebService$, secondWebService$]).subscribe(   
          ([firstResult, secondResult]) => {  
            sessionStorage.clear();  
            localStorage.clear();   
            this.cookiesService.deleteAll('/', 'b2clogin.com');   
          },
              (error) => {    
            console.error('Error:', error);   
          }
        );
      })
  }
    
  }
  /**
   * Close the side bar region
   */
  closeSidebar(menu: any) {
    //this.multiWorkspaceService.openNewWorkspace(menu);
    this.openSideBarMenu = false;
  }
  /**
   * Open the side bar region
   */
  openSidebar() {
    this.openSideBarMenu = true;
    this.messageService.hideMessage();
  }
  /**
   * Open the multi-worksapce bar
   */
  displayMultiWorkspacesBar() {
    this.expandedState = this.openWorspaceBar ? 'collapsed' : 'expanded';
    this.openWorspaceBar = !this.openWorspaceBar;
  }
  /**
   * Close the multi-worksapce bar
   */
  closeWorkspaceBar() {
    this.expandedState = 'collapsed';
    this.openWorspaceBar = false;
  }

  /**
   * Translate the menu
   * @param {Array} menu - the menu to translate
   */
  translateMenu(menu: Menu[]) {
    menu.forEach(item => {
      // translate item
      this.translate
        .get(this.MENU_ITEMS + item.label)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res: string) => {
          if (!res.includes(this.MENU_ITEMS)) {
            item.label = res;
          }
        });

      // translate sub items
      if (item.items) {
        this.translateMenu(item.items);
      }
    });
  }

  async getUser(email: string) {
    let payload = `{"email":"${email}"}`;
    this.homeService.getUserByEmail(payload).subscribe(response => {
      this.user = response;
      this.initials =
        this.user.name.substr(0, 1) +
        this.user.name.substr(this.user.name.lastIndexOf(' ') + 1, 1);
    });
  }

  ManualDoUsarioo() {
    if (this.isMasterClient()) {
      if (localStorage.getItem("s3brazilwebportalfe_locale_id") == "en") {
        return " 	Master Client User Guide"
      }
      return " 	Manual do Master Cliente"
    }
    else if (this.isMasterBO()) {
      if (localStorage.getItem("s3brazilwebportalfe_locale_id") == "en") {
        return " 	Master BO User Guide"
      }
      return " Manual do Master BackOffice"
    }
    else {
      if (localStorage.getItem("s3brazilwebportalfe_locale_id") == "en") {
        return " Operator User Guide"
      }
      return " Manual do Operador"
    }

  }


  activeMenu(event) {
    let node;
    if (event.target.tagName === 'A') {
      node = event.target;
    } else {
      node = event.target.parentNode;
    }
    let menuitem = document.getElementsByClassName('ui-menuitem-link');
    for (let i = 0; i < menuitem.length; i++) {
      menuitem[i].classList.remove('menuitem-active');
    }
    node.classList.add('menuitem-active');
  }

  //CUSTOM MENU
  selectTab(tab: string) {
    this.master = false;
    this.dashboard = false;
    this.home = false;
    if (tab === 'master') {
      this.master = true;
    } else if (tab === 'dashboard') {
      this.dashboard = true;
    } else if (tab === 'home') {
      this.home = true;
    }
  }

  hasPassivoPermission() {
    return this.customAuthenticationService.hasPermission(PermissionsType.access_passivo_santanderOper)

  }

  hasOperPermission() {
    return this.customAuthenticationService.hasPermission(PermissionsType.access_Ativo_santanderOper)

  }
  hasDashboardPermission() {
    // Usuario sempre tera um perfil, Master ou Master BO
    return this.customAuthenticationService.hasPermission(PermissionsType.acessarDashboard);
  }

  resetTimer() {
    this.time = TIME_TO_EXPIRE_SESSION;
    this.hideClock = true;
    this.timerclass = 'initial';
    document.getElementById('timer').replaceWith(this.elmClock);
  }

  /*
   ** method: timeout_control() void
   ** parameters:
   ** author: amsaadaoui
   ** author: fchikhrouhou
   ** desc: New thread for logout event in case of incative session
   * */
  timeout_control() {
    var lastTime = (new Date()).getTime();
    if (typeof Worker !== 'undefined') {
      // Create a new
      const worker = new Worker('./../app.worker', { type: 'module' });
      worker.onmessage = ({ data }) => {
        var currentTime = (new Date()).getTime();
        if (this.time >= 0) {
          if (this.time < 1000 || (TIME_TO_EXPIRE_SESSION < (currentTime - lastTime))) {
            this.logout();
            console.log("logout for timeout")
          } else {
            this.time = this.time - 1000;
            if (this.time <= this.halfTime && this.time > this.endTime) {
              this.hideClock = false;
              this.timerclass = 'halfTime';
            }
            if (this.time <= this.endTime) {
              this.timerclass = 'endTime';
            }
          }
        }
        lastTime = currentTime;
      };
      worker.postMessage('initEvent');
    } else {
      interval(1000)
        .pipe(takeUntil(this.destroy$))
        .subscribe(x => {
          var currentTime = (new Date()).getTime();
          if (this.time >= 0) {
            if (this.time < 1000 || (TIME_TO_EXPIRE_SESSION < (currentTime - lastTime))) {
              this.logout();
            } else {
              this.time = this.time - 1000;
              if (this.time <= this.halfTime && this.time > this.endTime) {
                this.hideClock = false;
                this.timerclass = 'halfTime';
              }
              if (this.time <= this.endTime) {
                this.timerclass = 'endTime';
              }
            }
          }
          lastTime = currentTime;
        });
    }
  }
  isOperator(): boolean {
    return this.profileManager.getProfile() == ProfileType.operator
  }

  openDialogVisualizarMeuCadastro() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '90vh';
    dialogConfig.width = '92vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.position = {
      top: '43px',
    };

    let dialogRef = this.dialog.open(
      MasterVisualizarMeuCadastroComponent,
      dialogConfig,
    );
   dialogRef.componentInstance.user.login = this.shared.mailUser;
  }

  openDialogPortfolioCode() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = 'auto';
    dialogConfig.width = '92vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.position = {
      top: '43px',
    };

    let dialogRef = this.dialog.open(
      ParametersSearchSecurityPortfolioMenuComponent,
      dialogConfig,
    );
  }

  openMenu(status: boolean) {
    this.display = false;
    this.displayDashboard = false;
    this.isOpen = status;
    if(status == true ){
      this.isDashboardOpen=false;
      this.isAtivoOpen=false;
    }
    
  }
  openMenuAtivo(status: boolean) {
    this.display = !this.display;
    this.isAtivoOpen = status;
  }
  openMenuDashboard(status: boolean) {
    this.displayDashboard = !this.displayDashboard;
    this.isDashboardOpen = status;
  }
  showDialogDashboard() {
    this.display=false;
    this.isAtivoOpen= false;
   /*  if (this.router.url != '/dashboard') {
      this.shared.idDashboardOpeartionsActive = false;
      this.shared.isDashboardHomeActive = true;
      this.shared.isDashboardOnlineCashActive = false;
      this.shared.isDashboardCotasActive = false;
      this.shared.isDashboardPLActive = false;
      this.shared.isDashboardAccumulatedManagementActive  = false;
      this.router.navigateByUrl('/dashboard');
      
    }
    else{ */
      this.displayDashboard = !this.displayDashboard;
      this.isDashboardOpen = !this.isDashboardOpen ;
    /* } */
    
   // this.router.navigateByUrl('/dashboard');
  }
  goToHome(){
    this.display=false;
    this.isAtivoOpen= false;
    this.displayDashboard = this.displayDashboard;
    this.isDashboardOpen = false;
    if (this.router.url != '/dashboard') {
      this.shared.idDashboardOpeartionsActive = false;
      this.shared.isDashboardHomeActive = true;
      this.shared.isDashboardOnlineCashActive = false;
      this.shared.isDashboardCotasActive = false;
      this.shared.isDashboardPLActive = false;
      this.shared.isDashboardAccumulatedManagementActive  = false;
      this.shared.isDashboardInsumosPendentesActive = false;
      this.router.navigateByUrl('/dashboard');
      
    }
    else{
      this.shared.idDashboardOpeartionsActive = false;
      this.shared.isDashboardHomeActive = true;
      this.shared.isDashboardOnlineCashActive = false;
      this.shared.isDashboardCotasActive = false;
      this.shared.isDashboardPLActive = false;
      this.shared.isDashboardAccumulatedManagementActive  = false;
      this.shared.isDashboardInsumosPendentesActive = false;
    }
     

  }
  showDialog() {
    this.display = !this.display;
    this.isAtivoOpen = true ;
    this.isDashboardOpen=false;
    this.displayDashboard = false;
  }
  toogleProfile() {
    this.profileManagerService.changeProfile();
  }
  downloadManualUsario() {
    if (this.isMasterClient()) {
      if (localStorage.getItem("s3brazilwebportalfe_locale_id") == "en") {
        this.downloadLayouts("assets/files/Master Client User Guide.pdf");
      }
      else {
        this.downloadLayouts("assets/files/Manual do Master Cliente.pdf");
      }


    }
    else if (this.isMasterBO()) {
      if (localStorage.getItem("s3brazilwebportalfe_locale_id") == "en") {
        this.downloadLayouts("assets/files/Master BO User Guide.pdf");
      }
      else {
        this.downloadLayouts("assets/files/Manual do Master BackOffice.pdf");
      }

    }
    else {//operator
      if (localStorage.getItem("s3brazilwebportalfe_locale_id") == "en") {
        this.downloadLayouts("assets/files/Operator User Guide.pdf");
      }
      else {
        this.downloadLayouts("assets/files/Manual do Operador.pdf");
      }

    }

    //window.open('assets/files/Layouts.zip', '_blank')


  }
  downloadLayouts(filePath) {
    var link = document.createElement('a');
    link.href = filePath;
    link.download = filePath.substr(filePath.lastIndexOf('/') + 1);
    link.click();
  }

  setMasterBo() {
    if (this.profileManagerService.isMasterBO()) {
      this.profileManagerService.setMasterBo();
    }
  }

  setMasterClient() {
    this.profileManagerService.setMasterClient();
  }
  isClientBo() {
    return this.profileManagerService.isClientBo();
  }
  isMasterBO() {
    return this.profileManagerService.isMasterBO();
  }
  isMasterClient() {
    return this.profileManagerService.isMasterClient();
  }
  prodEnvironment() {
    if (!this.widgets.parametros) {
      if (this.profileManagerService.isMasterBO()) {
        return true
      }
      else {
        return false
      }

    }
    else {
      return true
    }
  }
  initToSetCurrentConfig() {
    if (this.customAuthenticationService.isLoggedIn()) {
      localStorage.removeItem('externalDataLoaded');
      this.homeAcessoRapidoService.getLoggedUser()
      .subscribe(response => {
        this.getUser(response.login)
      })
      //if (await this.customAuthenticationService.updateJwt() == true) {
      this.customAuthenticationService
        .getUser()
        .then(response => {

          this.shared.userSso = response.userSso

          this.shared.isCaceis = response.isCaceis
          this.userSso = response.userSso
          this.customAuthenticationService.setPermissions(response);
          localStorage.setItem("idUser", response.id);
          if (response.language == "português" && localStorage.getItem("s3brazilwebportalfe_locale_id") != "pt") {
            localStorage.setItem("s3brazilwebportalfe_locale_id", "pt")
            window.location.reload()
          } else if (response.language == "inglês" && localStorage.getItem("s3brazilwebportalfe_locale_id") != "en") {
            localStorage.setItem("s3brazilwebportalfe_locale_id", "en")
            window.location.reload()
          }
          this.cookieAccepted = response.cookieAccepted;
          if (this.cookieAccepted == true) {
            this.isDisplayed = false;
          } else {
            this.isDisplayed = true;
          }
          
          if (response.status === 'Novo usuário') {
            this.customAuthenticationService.updateStatus();
          }
          this.getCurrentConfig()
          //this.showLoading = true;
          this.router.navigateByUrl('/dashboard');
         // this.showLoading = true;
          this.checkInvesmentGroup(response.id)
          if (response.status == "Bloqueado" || response.status == "Inativo") {
            if (response.language == "português") {
              this.messageServicess.add({
                severity: 'error', detail: "você não pode se conectar. Entre em contato com seu administrador.",
              });
            }
            else {
              this.messageServicess.add({
                severity: 'error', detail: "you can not connect. Please contact your administrator.",
              });
            }

            setTimeout(() => {
              this.logout();
            }, 2000);

          }
          // this.hasPassivoOperPermission = this.customAuthenticationService.hasPermission(PermissionsType.access_Ativo_santanderOper)
          // this.hasAtivoOperPermission = this.customAuthenticationService.hasPermission(PermissionsType.access_Ativo_santanderOper)
        })
        .catch(err => {
          this.router.navigateByUrl('/dashboard');
          this.customAuthenticationService.clearPermissions();
        });
      //}
    }
  }

  init() {
    if (this.customAuthenticationService.isLoggedIn()) {
      localStorage.removeItem('externalDataLoaded');
      this.customAuthenticationService
        .getUser()
        .then(response => {

          this.shared.userSso = response.userSso

          this.shared.isCaceis = response.isCaceis
          this.userSso = response.userSso

          localStorage.setItem("idUser", response.id);
          if (response.language == "português" && localStorage.getItem("s3brazilwebportalfe_locale_id") != "pt") {
            localStorage.setItem("s3brazilwebportalfe_locale_id", "pt")
            window.location.reload()
          } else if (response.language == "inglês" && localStorage.getItem("s3brazilwebportalfe_locale_id") != "en") {
            localStorage.setItem("s3brazilwebportalfe_locale_id", "en")
            window.location.reload()
          }
          this.cookieAccepted = response.cookieAccepted;
          if (this.cookieAccepted == true) {
            this.isDisplayed = false;
          } else {
            this.isDisplayed = true;
          }
          this.customAuthenticationService.setPermissions(response);
          if (response.status === 'Novo usuário') {
            this.customAuthenticationService.updateStatus();
          }
          //this.showLoading = true;
          this.router.navigateByUrl('/dashboard');
         // this.showLoading = true;
          this.checkInvesmentGroup(response.id)
          if (response.status == "Bloqueado" || response.status == "Inativo") {
            if (response.language == "português") {
              this.messageServicess.add({
                severity: 'error', detail: "você não pode se conectar. Entre em contato com seu administrador.",
              });
            }
            else {
              this.messageServicess.add({
                severity: 'error', detail: "you can not connect. Please contact your administrator.",
              });
            }

            setTimeout(() => {
              this.logout();
            }, 2000);

          }
          // this.hasPassivoOperPermission = this.customAuthenticationService.hasPermission(PermissionsType.access_Ativo_santanderOper)
          // this.hasAtivoOperPermission = this.customAuthenticationService.hasPermission(PermissionsType.access_Ativo_santanderOper)
        })
        .catch(err => {
          this.router.navigateByUrl('/dashboard');
          this.customAuthenticationService.clearPermissions();
        });
      //}
    }
  }
  loadComponentParameters(){
    NavigationHelper.loadComponent("/parameters/parameter-parent", this.router);
  }
  disagreeCookies() {
    this.customAuthenticationService.logout();
  }

  agreeCookies() {
    this.customAuthenticationService
      .acceptCookie(
        '',
        '',
      )
      .toPromise()
      .then(_ => {
        this.init();
      });
  }
  ngOnDestroy() {
    if (this.destroy$) {
      this.destroy$.next(true);
      this.destroy$.complete();
    }
  }

  /**
 * Open the page in a workspace and close the main menu's sidebar
 */
  openPage(menu: any) {
    this.open(menu)
    this.screenTitle = menu.label
    this.styleClass = menu.styleClass
  }

  /**
   * Open a page
   * @param menu
   */
  open(menu: any) {
    const link = menu.link ? menu.link[0] : undefined
    const externalLink = link ? link.startsWith('http') : link
    const isCurrentPage =
      link !== '/' &&
      (this.router.url.startsWith(link) || this.screenTitle === menu.label)
    externalLink
      ? window.open(link, menu.openWindow ? '_blank' : '_self')
      : isCurrentPage
        ? true
        : this.router.navigate(menu.link, { queryParams: menu.params })
    this.titleService.setTitle(menu.label)
  }


  isDevEnv() {
    if (environment.isUatOrProd == "DEV") {
      return true
    }
    return false
  }

  getPTFBYUSER() {
    this.serviceException.findPTFByUSER().subscribe(res => {
      let buildCriteria = ""
      let buildCriteriaForEyes = ""
      res.forEach(element => {
        if (buildCriteria == "") {
          buildCriteria = `institutionCode=="${element.portfolioCode}"`
        }
        else {
          buildCriteria = buildCriteria + "|" + `institutionCode=="${element.portfolioCode}"`;
        }

        if (buildCriteriaForEyes == "") {
          buildCriteriaForEyes = `portfolioCode=="${element.portfolioCode}"`
        }
        else {
          buildCriteriaForEyes = buildCriteriaForEyes + "|" + `portfolioCode=="${element.portfolioCode}"`;
        }

      });
      if (res.length) {
        this.shared.listPTFBYUSERForFilterForEyes = buildCriteriaForEyes

        this.shared.listPTFBYUSERForFilter = buildCriteria
      }
      else {
        this.shared.listPTFBYUSERForFilterForEyes = `portfolioCode=="${JSON.parse(this.secureStorage.getJsonValue('portfolioCode')).portfolioCode}"`

        this.shared.listPTFBYUSERForFilter = `institutionCode=="${JSON.parse(this.secureStorage.getJsonValue('portfolioCode')).portfolioCode}"`

      }
    })
  }
  checkInvesmentGroup(id) {
    if (!this.isMasterBO() && !this.isMasterClient()) {
      this.getClients(id).subscribe(res => {
        this.shared.checkValueOfInvestmentGroup = res.investmentGroups
      })
    }

  }
  getClients(id): Observable<any> {
    return this.httpClient.post<any[]>(
      `${this.BASE_PATH}/bff/users/view/`, { id: id }
    );
  }

}
export interface Menu {
  label: string;
  roles?: string[];
  items?: Menu[];
  link?: string[];
  command?: any;
}
